import { ModalProps } from "@chakra-ui/react"

export type MezoModalProps = Pick<ModalProps, "isOpen" | "onClose">

export enum OnboardingSteps {
  AUTHENTICATION = "authentication",
  ENTER_EMAIL = "enter-email",
  MAGIC_LINK = "magic-link",
}

export enum DepositPageTab {
  MANAGE = "manage",
  NEW_DEPOSIT = "new-deposit",
}

export enum LeaderboardPageTab {
  MATS = "mats",
  SATS = "sats",
}

export type LeaderboardProps<T> = {
  currentUserRank: number | null
  leaderboard: T[]
  isLeaderboardFullyFetched: boolean
  loadMore: () => void
}

export type LeaderboardRank = {
  rank: number | null
  place: number | null
  rankData: {
    trophy: string
    color: string
    text: string
  } | null
}
